import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <TopicsSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
        <AboutSection />
        <UpdatesSection />
        <FAQSection />
        <CardsSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}